import { Link } from "react-router-dom"

export const SidebarMenuButton = ({ children, onClick, title, href, visible, isOpen}) => {
    return (
        <Link
            to={href}
            className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } 
                ${visible ? "" : "hidden"} 
                cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center text-sm
                ${
                    href === '/'
                        ? window.location.pathname === '/'
                        ? 'bg-slate-300'
                        : ''
                        : window.location.pathname === href || window.location.pathname.startsWith(`${href}/`)
                        ? 'bg-slate-300'
                        : ''
                    }
                ${ isOpen ? '' : 'justify-center' }
            `}
            onClick={onClick}
        >
            {children}
            <p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>{title}</p>
        </Link>
    )
}